'use client';

import { cn } from '@/lib/utils';
import { memo, ReactNode } from 'react';

interface TitleDividerProps {
    title: ReactNode;
    wrapperClassName?: string;
    titleClassName?: string;
    dividerClassName?: string;
}

export const TitleDivider = memo(
    ({
        title,
        wrapperClassName,
        titleClassName,
        dividerClassName,
    }: TitleDividerProps) => {
        return (
            <div
                className={cn(
                    'divider flex items-center gap-1 py-1',
                    wrapperClassName
                )}
            >
                <span
                    className={cn(
                        'w-fit whitespace-normal text-base font-medium',
                        titleClassName
                    )}
                >
                    {title}
                </span>
                <div
                    className={cn('h-0.5 flex-1 bg-primary', dividerClassName)}
                />
            </div>
        );
    }
);

TitleDivider.displayName = 'TitleDivider';
